import { render, staticRenderFns } from "./AdsEditor.vue?vue&type=template&id=22dc1a52&scoped=true&"
import script from "./AdsEditor.vue?vue&type=script&lang=js&"
export * from "./AdsEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdsEditor.vue?vue&type=style&index=0&id=22dc1a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc1a52",
  null
  
)

export default component.exports